export const Config = {
    apiVersion: "2017-09-13",
    baseUrl: "https://xola.com/api"
};


// WEBPACK FOOTER //
// ./src/js/Xola/Config.js